import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-folder-minus-icon',
  templateUrl: './files-folder-minus.component.html'
})
export class FilesFolderMinusComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
